import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LogIn } from "lucide-react";
import { useAuth, homePath } from "../lib/auth";
import { useLang } from "../lib/i18n";
import { errCode } from "../lib/api";
import { LangToggle } from "../components/LangToggle";
import { Wordmark } from "../components/AppShell";
import { Inp } from "../components/Common";

export default function Login() {
  const { login } = useAuth();
  const { t, te } = useLang();
  const nav = useNavigate();
  const [sp] = useSearchParams();
  const [f, setF] = useState({ username: "", password: "" });
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const u = await login(f.username, f.password);
      nav(u.must_change_password ? "/change-password" : sp.get("next") || homePath(u), { replace: true });
    } catch (ex) { setErr(errCode(ex)); }
    setBusy(false);
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-[#800B28] text-white p-12">
        <Wordmark light className="h-16" />
        <div>
          <p className="eyebrow !text-rose-200">{t("app_name")} · Phase 1</p>
          <h1 className="text-5xl font-extrabold leading-tight mt-3">QR → Campo → Andén.<br />Un bin, un registro.</h1>
          <p className="mt-4 text-rose-100 max-w-md">One label, one harvest load, from field activation to dock weighing.</p>
        </div>
        <p className="text-xs text-rose-200">America/Santiago</p>
      </div>
      <div className="flex flex-col p-6 sm:p-10">
        <div className="flex justify-between items-center">
          <span className="lg:hidden"><Wordmark className="h-10" /></span>
          <span className="ml-auto"><LangToggle /></span>
        </div>
        <form onSubmit={submit} className="w-full max-w-sm m-auto space-y-5 py-10" data-testid="login-form">
          <div>
            <h2 className="text-3xl font-extrabold tracking-tight">{t("login")}</h2>
            <p className="text-slate-600 mt-1 text-sm">{t("login_sub")}</p>
          </div>
          <Inp label={t("username")} testid="login-username-input" autoCapitalize="none" autoComplete="username"
            value={f.username} onChange={(e) => setF({ ...f, username: e.target.value })} required />
          <Inp label={t("password")} testid="login-password-input" type="password" autoComplete="current-password"
            value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} required />
          {err && <p className="text-sm font-semibold text-red-700 bg-red-50 border border-red-200 rounded-lg p-3" data-testid="login-error">{te(err)}</p>}
          <button className="btn-primary w-full" disabled={busy} data-testid="login-submit-button"><LogIn size={20} />{t("login")}</button>
        </form>
      </div>
    </div>
  );
}
